import { createSlice } from "@reduxjs/toolkit";

const LoaderSliceActions2 = createSlice({
  name: "Loader2",
  initialState: {
    isLoading2: false,
  },
  reducers: {
    getLoaderAction2: (state, action) => {
      // console.log(action.payload,"a;ldjasldjsadljsadlkjsadlkj")
      state.isLoading2 = action.payload;
    },
  },
});

export const { getLoaderAction2 } = LoaderSliceActions2.actions;

export default LoaderSliceActions2.reducer;


